export default __webpack_public_path__ + "static/media/warning-fill.3739c600.svg";